import { render, staticRenderFns } from "./Therapist.vue?vue&type=template&id=6052fc9e&scoped=true&"
import script from "./Therapist.vue?vue&type=script&lang=js&"
export * from "./Therapist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6052fc9e",
  null
  
)

export default component.exports